import { pipe } from 'fp-ts/function';
import { map } from 'lodash/fp';
import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import {
    fetchPassportScannerIntegrations,
    getPassportScannerIntegrations,
    isFetching,
} from '@mews-commander/legacy-entities/src/ducks/passportScannerIntegrations';
import { CommanderThunkAction } from '@mews-commander/types';
import { IconName } from '@optimus-web/core';
import PassportScannerLink from '../PassportScannerLink';
import AsyncDropdown from './AsyncDropdown';

interface PassportScannerActionProps {
    entities?: ($TSFixMe | $TSFixMe)[]; // TODO: pt.instanceOf(IntegrationRedirect)
    reservationIds?: string[];
    onScan?: $TSFixMeFunction;
    onRedirect?: $TSFixMeFunction;
    close?: $TSFixMeFunction;
}

class PassportScannerAction extends Component<PassportScannerActionProps> {
    handlePassportScannerClick = (id: $TSFixMe, url: $TSFixMe) => {
        const { close, onRedirect, onScan, reservationIds } = this.props;
        // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
        close();

        if (url) {
            if (onRedirect) {
                onRedirect(url, reservationIds);
            }
        } else if (onScan) {
            onScan(id, reservationIds);
        }
    };

    renderScanners = map((passportScanner) => (
        <PassportScannerLink
            key={(passportScanner as $TSFixMe).id}
            onClick={this.handlePassportScannerClick}
            passportScanner={passportScanner}
        />
    ));

    render() {
        return <Fragment>{this.renderScanners(this.props.entities)}</Fragment>;
    }
}

const selector = createStructuredSelector({
    entities: getPassportScannerIntegrations,
    isFetching,
});

const fetchEntities = (): CommanderThunkAction => (dispatch) => {
    const enterpriseId = getCurrentEnterpriseId();
    dispatch(fetchPassportScannerIntegrations({ enterpriseId }));
};

export default pipe(
    PassportScannerAction,
    AsyncDropdown({ icon: IconName.Scanner, preLoading: true, hideEmpty: true }),
    connect(selector, {
        fetchEntities,
    })
);
